// Validátory pre slovenské firmy (IBAN + IČO).
// Extrahované z AddWorkspaceModal aby sa dali reuse-nuť v Nastaveniach (HI-04).

export function isValidIban(raw) {
  if (!raw) return false;
  const v = String(raw).replace(/\s+/g, '').toUpperCase();
  if (!/^SK\d{22}$/.test(v)) return false;
  // Mod-97 check (ISO 13616)
  const rearranged = v.slice(4) + v.slice(0, 4);
  const expanded = rearranged.replace(/[A-Z]/g, ch => (ch.charCodeAt(0) - 55).toString());
  let remainder = 0;
  for (let i = 0; i < expanded.length; i++) {
    remainder = (remainder * 10 + Number(expanded[i])) % 97;
  }
  return remainder === 1;
}

export function isValidIco(raw) {
  if (!raw) return false;
  return /^\d{6,8}$/.test(String(raw).trim());
}
